import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { Skeleton } from 'ui/skeleton';
import { colors, fontSizes, spacing } from 'ui/theme';

import { Workflow, WorkflowType } from '../../types';
import { selectSendActivity } from '../../selectors';

import { TableCell } from './TableCell';

const SendActivityStatsList = styled.ul`
  padding: 0;
  margin: 0;
`;

const SendActivityStat = styled.li`
  color: ${colors.textSecondary};
`;

const SendActivityNumber = styled.span`
  color: ${colors.textPrimary};
`;

const TextSkeletonContainer = styled.div`
  flex-grow: 1;
`;

const TextSkeleton = styled(Skeleton)`
  display: block;
  height: ${fontSizes.s16};
  margin-bottom: ${spacing.quarter};
  width: ${(props: { percentWidth: number }) => props.percentWidth}%;
`;

type WorkflowSendActivityCellProps = {
  workflow: Pick<Workflow, 'id' | 'workflowType'>;
};

export const WorkflowSendActivityCell = ({ workflow }: WorkflowSendActivityCellProps) => {
  const isPublished = workflow.workflowType === WorkflowType.PUBLISHED;
  const storedSendActivity = useSelector(selectSendActivity(workflow.id));
  const sendActivity = isPublished ? storedSendActivity : { inProgress: 0, finished: 0 };
  const isLoading = sendActivity === undefined;

  if (isLoading) {
    return (
      <TableCell>
        <TextSkeletonContainer data-test="workflow-send-activity-loading">
          <TextSkeleton percentWidth={85} />
          <TextSkeleton percentWidth={65} />
        </TextSkeletonContainer>
      </TableCell>
    );
  }

  return (
    <TableCell>
      <SendActivityStatsList>
        <SendActivityStat>
          <SendActivityNumber>{sendActivity?.inProgress || 0}</SendActivityNumber> in progress
        </SendActivityStat>
        <SendActivityStat>
          <SendActivityNumber>{sendActivity?.finished || 0}</SendActivityNumber> finished
        </SendActivityStat>
      </SendActivityStatsList>
    </TableCell>
  );
};
